var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.031 11.672c.532.437 1.407.437 1.938 0l4.633-4.758c.53-.437.53-1.148 0-1.586A1.567 1.567 0 0011.625 5H9V2a2 2 0 10-4 0v3H2.375c-.352 0-.703.11-.969.328-.539.438-.539 1.149 0 1.586l4.625 4.758zM13 13H1c-.547 0-1 .453-1 1v1c0 .547.453 1 1 1h12c.555 0 1-.453 1-1v-1c0-.547-.445-1-1-1z",
    fill: "currentColor"
  })));
};
export default SvgDownloadIcon;